/* eslint-disable array-callback-return */
export default function polygonToJson(geometry) {
  try {
    if (geometry.startsWith('POINT')) {

      const coordsText = geometry.replace('POINT(', '').replace(')', '');
      const [lat, lng] = coordsText.split(' ').map(parseFloat);

      if (isNaN(lat) || isNaN(lng)) {
        console.error('Coordenadas de ponto inválidas:', coordsText);
        return [[0, 0]];
      }

      return [[lat, lng]];
    }
    // Se for um polígono, mantém a lógica original
    else if (geometry.startsWith('POLYGON')) {
      let parsedPolygon = geometry
        .replace('POLYGON(', '')
        .replace('))', '')
        .replace('(', '')
        .split(' ')
        .join(', ');

      let value1 = parsedPolygon.split(',');

      let value2 = value1.map((str, position) => {
        if (value1.indexOf(str) % 2 === 1) {
          return [
            parseFloat(value1[position - 1]),
            parseFloat(value1[position]),
          ];
        }
      });

      let value3 = value2.filter((value) => value !== undefined);
      return value3;
    }
    else {
      console.error('Tipo de geometria não suportado:', geometry);
      return [[0, 0]];
    }
  } catch (error) {
    console.error('Erro ao processar geometria:', error);
    return [[0, 0]];
  }
}